import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <div>
        <p className={styles.text}>
          離任・転学したアカウントは「削除」ではなく、「無効化」の設定が必要です。
        </p>
        <ul className={styles.list}>
          <li className={styles.item}>
            先生・生徒のアカウントに回答やコメントなどの利用データがある場合、データの不整合を防ぐため削除することはできません。
          </li>
          <li className={styles.item}>
            無効化することで、アカウントは使用できなくなり、同じメールアドレスで新しい環境に登録することが可能になります。
          </li>
        </ul>
      </div>
    </div>
    <div>
      <p className={styles.heading}>【先生アカウントを無効化する場合】</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          学校管理画面の［先生登録］→［編集］→［アカウントを無効にする］にチェックを入れてください
        </li>
      </ul>
    </div>
    <div>
      <p className={styles.heading}>【生徒アカウントを無効化する場合】</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          学校管理画面の［生徒登録］→［編集］→教材対象、GEAR拡張の［無効］にチェックを入れてください
        </li>
      </ul>
    </div>
  </div>
);

export const DEACTIVATE_ACCOUNT_FAQ: FaqCategoryItem = {
  id: "deactivate-account-faq",
  question:
    "登録していた先生が離任することになった／生徒が転学することになった",
  Answer,
};
